import React from 'react';
import { useLocale } from '../context/LocaleContext';
import styles from '../styles/stepCommon.module.css';

interface StepLoginPromptProps {
  onLogin: () => void;
}

/**
 * Unified login prompt for all 12 step pages.
 * Covers: new users, expired sessions, and users arriving from bookmarks.
 */
const StepLoginPrompt: React.FC<StepLoginPromptProps> = ({ onLogin }) => {
  const { t } = useLocale();

  return (
    <div className={styles.loginPrompt}>
      <div className={styles.loginPromptContent}>
        <p>{t('step.login_prompt.body')}</p>
        <div className={styles.loginPromptButtonGroup}>
          <button onClick={onLogin} className={styles.loginPromptLoginButton}>
            {t('step.login_prompt.sign_in')}
          </button>
          <button onClick={onLogin} className={styles.loginPromptCreateAccountButton}>
            {t('step.login_prompt.create_account')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StepLoginPrompt;
